import React, { useState } from 'react'
import { useQuery } from '@apollo/client'
import Error from 'components/error'
import { useAuth } from 'lib/auth'
import { LessonReviewQuery } from './query'
import ReviewBookingSkeleton from './review-booking-skeleton'
import BuyLessonPackLayout from './BuyLessonPackLayout'

export default ({ previousUrl, lessonTypeId, lessonPackId }) => {
  const { isLoggedIn, user } = useAuth()
  const [selectedLessonPackId, setSelectedLessonPackId] = useState(
    lessonPackId || null,
  )

  const { data, loading, error } = useQuery(LessonReviewQuery, {
    variables: {
      id: lessonTypeId,
    },
  })

  if (loading) return <ReviewBookingSkeleton />
  if (error) return <Error error={error} />

  const lessonInfo = data?.lessonTypes?.[0]
  // useQuery ignores GraphQL errors, so missing lesson types arrive as empty data.
  if (!lessonInfo) {
    return <Error statusCode={404} />
  }
  if (isLoggedIn) {
    return (
      <BuyLessonPackLayout
        previousUrl={previousUrl}
        lessonInfo={lessonInfo}
        user={user}
        selectedLessonPackId={selectedLessonPackId}
        setSelectedLessonPackId={setSelectedLessonPackId}
      />
    )
  }
  return (
    <BuyLessonPackLayout previousUrl={previousUrl} lessonInfo={lessonInfo} />
  )
}
